
import { Component, Prop } from 'vue-property-decorator';
import Listing from 'ah-common-lib/src/common/components/listing/Listing.vue';
import { PaginatedQuery, ExportListType, Address, ClientListResponse } from 'ah-api-gateways';
import { clientTableFields } from '@/app/components/clients/tableFields/clientTableFields';
import ClientOnboardingStatusPill from '@/app/components/clients/ClientOnboardingStatusPill.vue';
import ClientAssigneesList from './ClientAssigneesList.vue';
import ClientIndividualsList from './ClientIndividualsList.vue';
import { useSettingsStore } from '@/app/store/settingsModule';
import { countryNameFromCC } from 'ah-common-lib/src/helpers/countries';
import { formatDate, SIMPLE_DATE_FORMAT } from 'ah-common-lib/src/helpers/time';

@Component({
  components: {
    ClientOnboardingStatusPill,
    ClientAssigneesList,
    ClientIndividualsList,
  },
})
export default class ClientListing extends Listing<ClientListResponse> {
  @Prop({ default: () => ({ tableFields: clientTableFields }) }) config!: { tableFields: any[] };

  @Prop({ default: false }) detailess!: boolean | string;

  @Prop({ required: false }) documentsTitle?: string;

  formatDate = formatDate;

  SIMPLE_DATE_FORMAT = SIMPLE_DATE_FORMAT;

  created() {
    this.settingsStore.loadCountries();
  }

  get settingsStore() {
    return useSettingsStore();
  }

  protected loadDataRequest(query: PaginatedQuery) {
    return this.$services.client.listClients(query);
  }

  protected downloadDataRequest(type: string, query: { [key: string]: any }) {
    return this.$services.client.downloadClientList(query, type as ExportListType, this.documentsTitle);
  }

  get countryName() {
    return (address?: Address) => {
      return address?.countryCode ? this.countryNameFromCC(address.countryCode) : '';
    };
  }

  get isStackedView() {
    return this.$mediaQuery.is('smDown');
  }

  countryNameFromCC(value: string) {
    return countryNameFromCC(value, this.settingsStore.allCountries) || '';
  }
}
